<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import uiStore from "../utils/UIStore";

export let addFiles = (files) => console.log("No function is given");

let uiTexts;
uiStore.textStore.subscribe((store) => {
	uiTexts = store.texts;
});
</script>

<div class="datei-upload" style="position:relative; flex:1;max-width:30%">
  <input
    accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/pdf,text/plain"
    id="myFile"
    multiple
    name="filename"
    on:change={(event) => {
      event.target["files"] ? addFiles(event.target.files) : null;
    }}
    type="file"
  />
  <label
    class="btn secondary doc-upload"
    for="myFile"
    style="position: relative; padding:8px;     line-height: 1.2rem;"
    >{uiTexts.fileUpload.buttonText}
    <span class="dropzone-hint">{uiTexts.fileUpload.dropzoneHint}</span>
    </label
  >
</div>

<style>
  input:focus {
    outline: auto;
  }

  input#myFile:focus + label.doc-upload,
  input:focus {
    outline: 2px solid #000;
    outline-offset: 1px;
  }

  input[type="file"] {
    opacity: 0;
    z-index: -1;
    position: absolute;
    top: -1px;
    left: 0;
    width: 0.1px;
    height: 0.1px;
    user-select: none;
  }

  .datei-upload label {
    padding-left: 40px !important;
    background-image: url(static/icon-upload.svg);
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 40px;
  }

  input[type="file"] {
    opacity: 0;
    z-index: -1;
    position: absolute;
    top: -1px;
    left: 0;
    width: 0.1px;
    height: 0.1px;
    user-select: none;
  }

  .doc-upload {
    display: inline-block;
    width: 100%;
    text-align: left;
  }

  .doc-upload .dropzone-hint {
    content: "Oder Datei hier ablegen";
    color: #999;
    position: absolute;
    max-width: 50%;
    right: 5px;
    top: 3px;
    font-size: 0.85rem;
    text-align: right;
    font-weight: normal;
    line-height: 1;
  }
    @media screen and (max-width: 995px) {
        .doc-upload .dropzone-hint {
            display: none;
        }
    }
</style>
